export default __webpack_public_path__ + "static/media/Group9230.80f5569b.svg";